import React from 'react'
import MainNav from './MainNav'
import MessageHistory from './MessageHistory'
import Input from './Input'

const Chat = () => {
  return (
    <div className='flex flex-col justify-between min-h-screen md:min-h-full col-span-2'>
      <MainNav />
      <MessageHistory />
      <Input />
    </div>
  )
}

export default Chat